import React from 'react';
import PropTypes from 'prop-types';

class SidebarRight extends React.Component {
    constructor(props) {
        super(props);
    }
    getName() {
      return 'SidebarRight';
    }
    render() {
      const className = this.props.open? 'sidebar-right-open' : '';
        return (
			<aside id="sidebar-right" className={"sidebar-right " + className}>
				<div className="nano">
					<div className="nano-content">
						<a href="#" onClick={e => {e.preventDefault(); this.props.onClose(e)} || (f => {})} className="mobile-close">
							Collapse <i className="fa fa-chevron-right"></i>
						</a>

						<div className="sidebar-right-wrapper">
              {this.props.children}
						</div>
					</div>
				</div>
			</aside>
        );
    }
}

SidebarRight.propTypes = {
  onClose : PropTypes.func,
  open : PropTypes.bool,
}

export default SidebarRight;



// WEBPACK FOOTER //
// ./src/browser/components/ui/sidebar-right.js